
<div class="upcoming-meal-selection">
  <b-row align-h="center" justify="center" class="mb-3">
    <b-col cols="12" md="8">
      <p class="text-center text-muted">
        Make your selections by {{ formatCutoffDateTime(cutoffDateTime) }}
      </p>
    </b-col>
  </b-row>

  <b-row v-if="loading" key="loading" class="text-center pt-3">
    <b-col cols="12">
      <Spinner :size="100" centered />
    </b-col>
  </b-row>

  <div v-else>
    <b-row align-h="center" class="mb-4">
      <b-col cols="12" md="6">
        <b-card class="delivery-details">
          <h4>Delivery Details</h4>
          <div class="delivery-info">
            <p>
              <strong>Subscription:</strong> {{ rotatingSubscription.name }}
            </p>
            <p>
              <strong>Delivery Date:</strong>
              {{ formatDateTime(scheduledDateTime) }}
            </p>
            <p>
              <strong>Selection Deadline:</strong>
              {{ formatDateTime(cutoffDateTime) }}
            </p>
            <p>
              <strong>Required Selections:</strong>
              {{ rotatingSubscription.min_items }} -
              {{ rotatingSubscription.max_items }} meals
            </p>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-row align-h="center" class="mb-3">
      <b-col cols="12" md="8">
        <b-alert
          :show="isPastCutoffTime"
          variant="warning"
          class="text-center"
        >
          The selection deadline has passed. Any changes you make now may not
          be reflected in your order.
        </b-alert>
      </b-col>
    </b-row>

    <b-row align-h="center" class="mb-3">
      <b-col cols="12" md="8">
        <b-alert
          :show="saveSuccess"
          variant="success"
          dismissible
          class="text-center"
          @dismissed="saveSuccess = false"
        >
          Your meal selections have been saved successfully!
        </b-alert>
      </b-col>
    </b-row>

    <b-row align-h="center" class="mb-3">
      <b-col cols="12" md="8">
        <b-alert
          :show="saveError"
          variant="danger"
          dismissible
          class="text-center"
          @dismissed="saveError = false"
        >
          {{ errorMessage }}
        </b-alert>
      </b-col>
    </b-row>

    <ProductGrid
      v-if="products.length > 0"
      :products="products"
      :rotating-subscription="rotatingSubscription"
      :meals-selected="mealsSelected"
      :can-edit="!isPastCutoffTime"
      @add-to-cart="addToSelection"
      @toggle-favorite="toggleFavorite"
    />

    <b-row v-else class="text-center no-products pt-3">
      <b-col cols="12">
        <h3>No products available for selection</h3>
        <p>Please check back later or contact customer service.</p>
      </b-col>
    </b-row>

    <b-row align-h="center" class="mt-4">
      <b-col cols="12" md="6" class="d-flex justify-content-center">
        <b-button
          variant="primary"
          size="lg"
          :disabled="!isSelectionValid || saving || isPastCutoffTime"
          class="w-100"
          @click="saveSelections"
        >
          <b-spinner v-if="saving" small />
          <span v-else>Save Selections</span>
        </b-button>
      </b-col>
    </b-row>
  </div>
</div>
